import { Loader, Share2 } from 'lucide-react';
import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRestClient } from '../../../api/RestClientContext';
import { copyToClipboard } from '../../../utils/clipboard';
import { getTelegramWebApp } from '../../../utils/telegram';
import '../styles/ShareReferralButton.css';

interface ShareReferralButtonProps {
    className?: string;
}

export const ShareReferralButton: React.FC<ShareReferralButtonProps> = ({ className = '' }) => {
    const restClient = useRestClient();
    const [loading, setLoading] = useState(false);
    const nav = useNavigate()

    const handleShare = useCallback(async () => {
        try {
            setLoading(true);

            const response = await restClient.getReferralHash();
            
            if (!response.result) {
                toast.error('Не удалось получить реферальную ссылку');
                return;
            }

            const referralLink = response.result;

            const tg = getTelegramWebApp();
            if (tg) {
                nav("/loyalty")
                tg.openTelegramLink(`https://t.me/share/url?url=${encodeURIComponent(referralLink)}&text=${encodeURIComponent('Присоединяйся ко мне в OgoSecureAccess! Подписка активируется после того как нажмешь кнопку "НАЧАТЬ"')}`);
            } else {
                const ok = await copyToClipboard(referralLink);
                if (ok) {
                    toast.success('Ссылка скопирована в буфер обмена');
                } else {
                    toast.error('Ошибка при копировании ссылки');
                }
            }
        } catch (error) {
            console.error('Ошибка при попытке поделиться:', error);
            toast.error('Ошибка при попытке поделиться');
        } finally {
            setLoading(false);
        }
    }, [restClient]);

    return (
        <button
            className={`share-referral-button glass-ui ${className}`.trim()}
            onClick={handleShare}
            disabled={loading}
            title="Поделиться реферальной ссылкой"
        >
            <div className="share-referral-content">
                {loading ? (
                    <Loader size={20} className="share-icon spin" />
                ) : (
                    <Share2 size={20} className="share-icon" />
                )}
                <span className="share-text">поделиться приложением</span>
            </div>
        </button>
    );
};

